module.exports = __webpack_public_path__ + "static/androidBannerAutoMarket-ce32b2f9293b19123b24c6145edf2c7e.jpg";